<template>
  <div class="auth-card-item">
    <img :src="config.images[0]" class="card-bg" />
    <div class="card-content" :class="`card-content-${idx}`">
      <div class="card-content--left">
        <div class="card-content-title">
          {{ config.title }}
        </div>
        <div v-for="tip in config.tips" :key="tip" class="tip-item">
          {{ tip }}
        </div>
      </div>
      <div
        v-if="['Not', 'No'].includes(status)"
        class="auth-btn"
        :class="[`auth-${idx}`, 'auth', { disabled: idx > userKYCLevel }]"
        @click="
          idx <= userKYCLevel && $router.push({ path: `/KYCAuth/${idx + 1}` })
        "
      >
        {{ status === 'Not' ? $t('去认证') : $t('重新认证') }}
      </div>

      <template v-if="status === 'Yes'">
        <img :src="config.images[1]" class="auth-img-1" />
      </template>
      <template v-if="['Yes', 'No', 'Checking'].includes(status)">
        <div class="status-box">
          <img
            :src="
              require(`@/assets/images/${
                {
                  Yes: 'certified',
                  No: 'review_faild',
                  Checking: 'pending'
                }[status]
              }.png`)
            "
            class="status-box-bg"
          />

          <div
            class="status-text"
            :class="{
              certified: status === 'Yes',
              review_faild: status === 'No',
              pending: status === 'Checking'
            }"
          >
            {{
              {
                Yes: $t('已认证'),
                No: $t('审核未通过'),
                Checking: $t('审核中')
              }[status]
            }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AuthCard',
  props: {
    idx: Number,
    config: Object,
    status: String,
    userKYCLevel: Number
  }
}
</script>
<style scoped lang="less">
.auth-card-item {
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  width: 514px;
  height: 176px;
  margin-top: 32px;
  &:first-child {
    margin-top: 57px;
  }
  &:last-child {
    margin-bottom: 100px;
  }

  .card-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .card-content {
    padding-left: 24px;
    padding-right: 24px;
    height: 100%;
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .auth-btn {
      // width: 96px;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      text-align: center;

      border-radius: 32px 32px 32px 32px;

      font-size: 16px;
      font-weight: 500;

      &.auditing {
        background: #e0e2e4;
        color: #999eb4;
      }
      &.auth {
        background: #ffffff;
        cursor: pointer;
        &.auth-0 {
          color: #e18a21;
        }
        &.auth-1 {
          color: #286ed8;
        }
        &.auth-2 {
          color: #285295;
        }
        &.disabled {
          cursor: not-allowed;
          background: #e0e2e4;
          color: #999eb4;
        }
      }
    }
    &-title {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 16px;
    }
    .tip-item {
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
      &:not(:first-child) {
        margin-top: 4px;
      }
    }
    &.card-content-0 {
      color: #925200;
    }
    &.card-content-1 {
      color: #00327d;
    }
    &.card-content-2 {
      color: #ffffff;
    }
  }
  .auth-img-1 {
    position: absolute;
    bottom: 0;
    right: 32px;
    width: 142px;
    height: 151px;
  }
  .status-box {
    position: absolute;
    right: 0;
    top: 0;
    width: 145px;
    height: 28px;
    padding-left: 32px;
    padding-right: 12px;

    .status-box-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .status-text {
      line-height: 28px;
      text-align: center;
      position: relative;
      z-index: 10;
      font-size: 13px;
      font-weight: 500;
      color: #ffffff;

      &.certified {
        color: #cbc59a;
        &::before,
        &::after {
          background: #cbc59a;
        }
      }
      &.review_faild {
        color: #ff4141;
        &::before,
        &::after {
          background: #ff3f4a;
        }
      }
      &.pending {
        color: #fff;
        &::before,
        &::after {
          background: #fff;
        }
      }

      &::before {
        display: block;
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
      &::after {
        display: block;
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
